import { sortItemsByProperty } from './sortItemsByProperty';
import { ItemSort } from './types';

type SortItemsByManyPropertiesParam<TItem> = {
  items: TItem[];
  itemSorts: ItemSort<TItem>[];
};

/**
 *
 * This is used for sorting an array of items by many different properties.
 *
 * @param options
 * @param options.items The collection of items to sort
 * @param options.itemSorts a list of sorts to apply.
 */
export const sortItemsByManyProperties = <TItem>({
  items,
  itemSorts,
}: SortItemsByManyPropertiesParam<TItem>) =>
  itemSorts.reduce(
    (items, sort) => sortItemsByProperty({ items, ...sort }),
    [...items]
  );
